import classNames from 'classnames/bind';
import { memo } from 'react';

import styles from './StatusProposedChange.module.scss';

interface IProps {
  title: string;
  type: 'success' | 'pending' | 'reject';
}

const cx = classNames.bind(styles);

export const StatusProposedChange = memo(({ title, type }: IProps) => {
  const classes = cx('status', { [type]: type });

  return <p className={classes}>{title}</p>;
});
